import React, { useState, useEffect, useLayoutEffect } from 'react'
import './Booking.css'
import {PlanningDetail} from '../Planning/PlanningDetail'
import {BookingDetail} from './BookingDetail'
import {meSplitter} from '../Shared/meLayout'

export const Booking = ({global, layout, search}) => {
        const entity = Booking.name;

        const [itemId, setItemId] = useState(0)

        const main = new meSplitter(`${entity}Side`,`${entity}Container`, layout)

        useLayoutEffect (()=>{  
                main.selectorAll() 
                //alert(main.items.length)      
        },[])

        const onSelect = (itemId) => {
                setItemId(itemId)
                //      alert("Booking  "+itemId)
        }

        useEffect(() => {
                //alert('useEffect '+itemId)
        }, [itemId])    


return (

<>
                
{ global.connected() ?
<div className="Sides" id={`${entity}Container`}
onMouseDown={(e)=>{main.mouseDown(e)}} 
onMouseMove={(e)=>{main.mouseMove(e)}} 
onMouseUp={(e)=>{main.mouseUp(e)}}
>
                <div className="side vside" id={`${entity}SidePlanning`} style={layout ?{width:'50%'}:{height: '50%'}} >
                        <PlanningDetail global={global} onPlan={onSelect}/>
                </div>  

                <div className="side vside" id={`${entity}SideBooking`} style={layout ?{width:'50%'}:{height: '50%'}}>
                        <BookingDetail PlanningId={itemId} />
                </div>                      
</div>
: <h5>Invalid session?</h5> }

</>
        )
}
